import { useState } from 'react'

import { FvButton } from '@fv/client-components'
import type { FullShipment, PropsWithClassName } from '@fv/client-types'

import { ValidatedForm } from '@/components/inputs'
import { InputAdornment } from '@/components/inputs/InputGroup'

import { useAccountSettings } from '../settings/account-settings/hooks'
import { GLCodeSelector } from './GLCodeSelector'
import { useEditGLCode } from './useEditGLCode'

type Props = PropsWithClassName<{
  load: FullShipment
}>

export const GLCodeEditor = ({ load, className }: Props) => {
  const [isEditing, setIsEditing] = useState(false)
  const [glCode, setGlCode] = useState(load.glCode || '')
  const saveGLCode = useEditGLCode(load.loadId)
  const settings = useAccountSettings()

  const handleSave = async () => {
    await saveGLCode.mutateAsync({ glCode })
    setIsEditing(false)
  }

  const handleCancel = () => {
    setGlCode(load.glCode || '')
    setIsEditing(false)
  }

  if (isEditing) {
    return (
      <ValidatedForm onValidSubmit={handleSave} className="flex items-center">
        <GLCodeSelector
          value={glCode}
          onChange={setGlCode}
          required={settings.glCode?.required}
        />
        <InputAdornment position="end">
          <FvButton
            theme="default"
            icon="check"
            type="submit"
            loading={saveGLCode.isPending}
          >
            Save
          </FvButton>
        </InputAdornment>
        <InputAdornment position="end">
          <FvButton
            theme="plain"
            icon="times"
            className="pr-0"
            iconClass="text-fv-orange-bright"
            onClick={handleCancel}
            loading={saveGLCode.isPending}
          />
        </InputAdornment>
      </ValidatedForm>
    )
  }

  return (
    <FvButton
      className={className}
      onClick={() => setIsEditing(true)}
      type="button"
      theme="underlined"
    >
      GL Code: {load.glCode || 'None'}
    </FvButton>
  )
}
